import './main.less';

import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/fp/isEmpty';

import ShopInfo from './shop-info';
import GoodCard from '../goodCard/main';
import Shop from './shop';

const Main = props => {
	const { intl, searchGoods, user, goods, currentLang, toggleCategoryItem, query, toggleOnlyAvailable, goodCardNumber,
		categories, toggleOrderItem, popupInfo, handleOrder, hidePopup, paginateGoods, initPopup, saveUpForGood,
		isOrderButtonDisabled } = props;
	return (
		<main className='main'>
			{_isEmpty(user) &&
				<a className='btn intro-btn btn_hover registration_btn'
					href='https://rocketprofit.com'
				>
					{intl('Registration')}
				</a>
			}
			<div className='container'>
				<ShopInfo
					intl={intl}
					user={user}
				/>
				<Shop
					intl={intl}
					user={user}
					goods={goods.rows}
					query={query}
					searchGoods={searchGoods}
					saveUpForGood={saveUpForGood}
					goodCardNumber={goodCardNumber}
					goodsTotal={goods.total.toString()}
					paginateGoods={paginateGoods}
					toggleOrderItem={toggleOrderItem}
					toggleOnlyAvailable={toggleOnlyAvailable}
					popupInfo={popupInfo}
					currentLang={currentLang}
					handleOrder={handleOrder}
					hidePopup={hidePopup}
					categories={categories}
					isOrderButtonDisabled={isOrderButtonDisabled}
					toggleCategoryItem={toggleCategoryItem}
					initPopup={initPopup}
				/>
				{goodCardNumber &&
					<GoodCard
						intl={intl}
						goods={goods}
						user={user}
						goodCardNumber={goodCardNumber}
						handleOrder={handleOrder}
						saveUpForGood={saveUpForGood}
					/>
				}
			</div>
		</main>
	);
};

Main.propTypes = {
	intl: PropTypes.func,
	paginateGoods: PropTypes.func,
	goodCardNumber: PropTypes.number,
	toggleCategoryItem: PropTypes.func,
	toggleOrderItem: PropTypes.func,
	saveUpForGood: PropTypes.func,
	toggleOnlyAvailable: PropTypes.func,
	searchGoods: PropTypes.func,
	initPopup: PropTypes.func,
	hidePopup: PropTypes.func,
	user: PropTypes.object,
	query: PropTypes.object,
	goods: PropTypes.object,
	currentLang: PropTypes.string,
	popupInfo: PropTypes.object,
	handleOrder: PropTypes.func
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/store/main.js